import { useEffect } from 'react';

/**
 * Injecte le comportement drawer mobile dans les dashboards dashboard-dg-root.
 * Ajoute automatiquement le bouton ☰, l'overlay, et gère l'ouverture/fermeture.
 */
export function useMobileSidebar() {
  useEffect(() => {
    const root = document.querySelector('.dashboard-dg-root');
    if (!root) return;

    const topbarLeft = root.querySelector('.topbar-left');
    const sidebar = root.querySelector('.sidebar');
    if (!topbarLeft || !sidebar) return;

    // Éviter les doublons
    if (root.querySelector('.menu-toggle')) return;

    // Bouton ☰
    const btn = document.createElement('button');
    btn.className = 'menu-toggle';
    btn.textContent = '☰';
    btn.setAttribute('aria-label', 'Menu');
    topbarLeft.insertBefore(btn, topbarLeft.firstChild);

    // Overlay
    const overlay = document.createElement('div');
    overlay.className = 'sidebar-overlay';
    root.querySelector('.layout')?.insertBefore(overlay, sidebar);

    const open = () => { sidebar.classList.add('open'); overlay.classList.add('open'); };
    const close = () => { sidebar.classList.remove('open'); overlay.classList.remove('open'); };

    btn.addEventListener('click', open);
    overlay.addEventListener('click', close);

    // Fermer quand on clique sur un item de la sidebar
    sidebar.querySelectorAll('.sb-item').forEach(item => {
      item.addEventListener('click', close);
    });

    return () => {
      btn.removeEventListener('click', open);
      overlay.removeEventListener('click', close);
      btn.remove();
      overlay.remove();
    };
  });
}
